import { render, staticRenderFns } from "./CustomizationOfferEdit.vue?vue&type=template&id=4131a276&scoped=true"
import script from "./CustomizationOfferEdit.vue?vue&type=script&lang=js"
export * from "./CustomizationOfferEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131a276",
  null
  
)

export default component.exports